/* global axios */

import ApiClient from './ApiClient';

class CampaignsAPI extends ApiClient {
  constructor() {
    super('campaigns', { accountScoped: true });
  }

  generateVariations(payload) {
    return axios.post(`${this.url}/generate_variations`, payload);
  }

  variationsConfig() {
    return axios.get(`${this.url}/variations_config`);
  }

  update(id, data) {
    if (data instanceof FormData) {
      return axios.patch(`${this.url}/${id}`, data, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
    }

    return super.update(id, data);
  }
}

export default new CampaignsAPI();
